import {StyleSheet} from 'react-native';

import {black} from '/theme/color/on.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  base: {},
  // @ts-expect-error TS(2322): Type '{ fontFamily: string; fontWeight: string | u... Remove this comment to see the full error message
  headerGreetingText: {
    color: black,
    fontSize: 22,
    flexShrink: 1,
    ...getFontFamily('bold'),
  },
});
